import { Accordion, Grid, Stack, styled, Typography } from "@mui/material";

export const CustomAccordion = styled(Accordion)(
  ({ theme, expanded, isLast }) => ({
    backgroundColor: expanded ? "#0C2E52" : "#fff",
    color: !expanded ? "#0C2E52" : "#fff",
    borderRadius: "24px",
    marginBottom: isLast ? "0rem" : "1rem", // Appliquer la bonne marge en fonction de isLast
    padding: "0.2rem",
    width: "-webkit-fill-available",
    height: "auto",
    "& .MuiAccordionSummary-root": {
      fontWeight: 700,
      padding: "1.2rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& .MuiAccordionDetails-root": {
      backgroundColor: "#0C2E52",
      borderRadius: "24px",
      color: "#FFF",
      padding: "0rem 1.2rem 1.2rem 1.2rem",
    },
    "&:first-of-type": {
      borderTopLeftRadius: "24px",
      borderTopRightRadius: "24px",
    },
    "&:last-of-type": {
      borderBottomLeftRadius: "24px",
      borderBottomRightRadius: "24px",
    },
    [theme.breakpoints.down(1100)]: {
      "& .MuiAccordionSummary-root": {
        padding: "12px 16px !important",
      },
    },
    [theme.breakpoints.down("md")]: {
      "& .MuiPaper-root-MuiAccordion-root": {
        height: "100px",
      },
      "& .MuiTypography-root": {
        fontSize: "20px",
      },
      "& .MuiAccordionDetails-root": {
        padding: "0.8rem",
      },
      width: "80%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  })
);

export const CustomImg = styled("img")(({ theme }) => ({
  height: "674px",
  width: "auto",
  borderRadius: "20px",
  objectFit: "cover",
  [theme.breakpoints.down(1100)]: {
    height: "592px",
  },
  [theme.breakpoints.down("md")]: {
    height: "412px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "346px",
  },
}));

export const CustomGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const TitleAccordion = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "1.5rem",
  flex: 1,
  [theme.breakpoints.down(1100)]: {
    fontSize: "16px !important",
  },
}));

export const DescriptionAccordion = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  [theme.breakpoints.down(1100)]: {
    fontSize: "16px",
  },
}));
export const GridAccordion = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
}));
export const ImgCard = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {},
}));
export const StackStyled = styled(Stack)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexDirection: "row",
  gap: "1rem",
}));
